import { Helmet } from "react-helmet";

interface IEnablePinchZoomingProps {
    /** Optional fixed viewport width in pixels. When provided, the browser renders content at this
     * width and scales it down to fit the screen, preserving the original layout without the need to horizontally scroll.
     * @default undefined - When omitted, defaults to device-width; can cause wrapping and/or horizontal scrolling.
     */
    width?: number;
}

/** When added to a component, ANY page the component is rendered on will become pinch-zoomable on mobile.
 * This type of zooming in/out doesn't affect the document layout's width and height, it scales the view rather than the content.
 */
export const EnablePinchZooming = ({ width }: IEnablePinchZoomingProps) => {
    const viewportWidth = width ?? "device-width";

    return (
        <Helmet>
            <meta name="viewport" content={`width=${viewportWidth}, user-scalable=yes`} />
        </Helmet>
    );
};
